export default __webpack_public_path__ + "static/media/RoastBeef.ae5a5065.jpg";